export default "__VITE_ASSET__6d807fd3__"